export default __webpack_public_path__ + "static/media/calender.fecdf8c5.svg";